function customFilter() {
  if (!$("#filters>.h2").length) {
    $("#filters")
      .prepend(
        '<div class="h2">Filtrovat</div><button class="CloseFilters closeTop" type="button" title="Filtrovat"></button>',
      )
      .append(
        '<div class="bottomFilterButton"><button class="CloseFilters closeBottom btn-conversion btn btn-primary" type="button" title="Filtrovat">Filtrovat</button></div>',
      );
  }


  $("#filters .filter-sections").append($("#filters .slider-wrapper"));
  $(".slider-wrapper").addClass("filter-section");
  if (!$(".filter-section-boolean .param-filter-top>h4").length) {
    $(".filter-section-boolean .param-filter-top")
      .addClass("filter-section")
      .prepend("<h4><span>" + "Štítky" + "</span></h4>")
      .prependTo("#category-filter-hover");
  }
  $("body")
    .off("click.customFilter", "#filters .filter-section h4")
    .on("click.customFilter", "#filters .filter-section h4", function () {
      $(this).closest(".filter-section").toggleClass("openIt");
    });

  $(".filter-section").addClass("openIt");
  var otherElements = $(".filter-section").not(openFilters.join(","));
  otherElements.removeClass("openIt");
  $(".filter-section").each(function () {
    if ($(this).find(".filter-label.active").length) {
      $(this).addClass("openIt");
    }
  });
}
function showActiveFilters() {
  const $activeLabels = $(".filter-label.active");
  const hasActive = $activeLabels.length > 0;
  let $wrapper = $(".chooseFilters");
  if (!hasActive) {
    $wrapper.remove();
  } else {
    if (!$wrapper.length) {
      $wrapper = $('<div class="chooseFilters"></div>').insertBefore(
        "#category-header",
      );
    }
    $wrapper.empty();

    $wrapper.prepend("<div>Vybrané filtry:</div>");
    $activeLabels.each(function () {
      $wrapper.append($(this).clone().removeClass("active"));
    });

    const $clear = $("#clear-filters");
    if ($clear.length) {
      const $clearClone = $clear.clone(true, true);

      $clearClone.addClass("clear-all-filters").find("a").text("smazat filtry");

      $wrapper.append($clearClone);
    }
  }

  $(document)
    .off("click.showActiveFilters", ".chooseFilters label.filter-label")
    .on(
      "click.showActiveFilters",
      ".chooseFilters label.filter-label",
      function () {
        const scrollTop = $(window).scrollTop();

        requestAnimationFrame(function () {
          $(window).scrollTop(scrollTop);
        });

        setTimeout(function () {
          $(window).scrollTop(scrollTop);
        }, 50);
      },
    );
}

function customCategory() {

  if (
    $(".category__secondDescription").length &&
    !$("#content>.category__secondDescription").length
  ) {
    $("#content").append($(".category__secondDescription").clone());
  }
  $("a.pagination__link--prev").closest("li").addClass("prev");
  $("a.pagination__link--next").closest("li").addClass("next");
  $(".loadMore__button").text(
    "Načíst dalších " +
    $(".loadMore__button").text().replace(/\D/g, "") +
    " produktů",
  );

  if ($(".category-perex .help").length) {
    $(".category-top").append($(".category-perex .help"));
  }

  $(function () {
    function truncateHtml($source, limit) {
      let currentLength = 0;
      let isLimitReached = false;

      const $wrapper = $('<div></div>');

      function walkNode(node, $targetParent) {
        if (isLimitReached) {
          return;
        }

        if (node.nodeType === Node.TEXT_NODE) {
          const text = node.nodeValue;
          const remaining = limit - currentLength;

          if (text.length <= remaining) {
            $targetParent.append(document.createTextNode(text));
            currentLength += text.length;
          } else {
            let sliced = text.substring(0, remaining);

            // ať to nekončí uprostřed slova
            const lastSpace = sliced.lastIndexOf(' ');
            if (lastSpace > 50) {
              sliced = sliced.substring(0, lastSpace);
            }

            $targetParent.append(document.createTextNode(sliced + '...'));
            currentLength = limit;
            isLimitReached = true;
          }

          return;
        }

        if (node.nodeType === Node.ELEMENT_NODE) {
          const $clone = $(node).clone(false).empty();

          $targetParent.append($clone);

          $(node).contents().each(function () {
            walkNode(this, $clone);
          });
        }
      }

      $source.contents().each(function () {
        walkNode(this, $wrapper);
      });

      return $wrapper.html();
    }

    $('.category-perex').each(function () {
      const limit = 500;
      const $this = $(this);
      const fullHtml = $this.html();
      const fullText = $.trim($this.text());

      if (fullText.length <= limit) {
        return;
      }

      const shortHtml = truncateHtml($this, limit);

      $this.html(`
      <div class="category-perex-short">
        ${shortHtml}
      </div>
      <button type="button" class="show-more">Zobrazit více</button>
    `);

      $this.on('click', '.show-more', function () {
        $this.html(fullHtml);
      });
    });
  });
}
function customSorting() {
  if (!$(".category-content-wrapper>.customSorting").length) {
    $(".category-content-wrapper").prepend(
      '<span class="customSorting btn btn-primary">Seřadit dle</span>',
    );
  }
}

$("html").on("click", ".customSorting", function () {
  $("#category-header").toggleClass("show");
  $(this).toggleClass("active");
});

$("html")
  .off("click.customFilterClose", ".filters .CloseFilters")
  .on("click.customFilterClose", ".filters .CloseFilters", function () {
    $("#filters-wrapper .filters-unveil-button-wrapper a").trigger("click");
     $("#filters-wrapper .filters-unveil-button-wrapper a")
      .text("Filtrovat")
      .attr("data-text", "Zavřít filtr ");
  });


function initFilterHint() {
  if ($('body.mobile').length && !$('.category-content-wrapper #filters-wrapper .filters-unveil-button-wrapper').length) {
    $('.category-content-wrapper #filters-wrapper').append($('.filters-unveil-button-wrapper').clone());
  }

  $(document).ready(function () {
    $(".filters-unveil-button-wrapper a")
      .text("Filtrovat")
      .attr("data-text", "Zavřít filtr ");

    if ($("body.mobile:not(.filters-visible)").length) {
      $("#filters").removeClass("visible");
    }

  });
  customFilter();
  customSorting();
  showActiveFilters();
  customCategory();
}

if ($(".type-category").length) {
  $(document).ready(function () {
    if ($("body.mobile").length) {
      $("#filters").removeClass("visible");
    }

  });

  renderRecentlyViewed();
  $(document).ready(initFilterHint);
  document.addEventListener("ShoptetDOMPageContentLoaded", initFilterHint);
  document.addEventListener("ShoptetPageSortingChanged", initFilterHint);
  document.addEventListener("ShoptetDOMPageMoreProductsLoaded", initFilterHint);
  document.addEventListener("ShoptetDOMContentLoaded", initFilterHint);
}
